import React from 'react';
import ReactDOM from 'react-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import { BrowserRouter } from 'react-router-dom';
import http from 'http';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import { AppRegistry } from 'react-native'

import Media from "react-media";

const supportsHistory = 'pushState' in window.history;
const history = createBrowserHistory()
document.onreadystatechange = function (e) {
    switch (document.readyState) {
        case "loading":
            // The document is still loading.
            
            break;
        case "interactive":
            // The document has finished loading. We can now access the DOM elements.
            
            break;
        case "complete":
            // The page is fully loaded.
            
            break;
    }
};

class Redirect extends React.Component{
    componentDidMount = () => {
      setTimeout(()=>{
          const url = process.env.NODE_ENV !== 'production'?"http://localhost:9000":"http://mobile.supotsu.com";
          window.location = url;
          console.log(url)
      }, 500);
    };
    
    render(){
        return(
            <div/>
        )
    }
}

const _App = (props) => (
    <Media query="(max-width: 1024px)">
    {matches =>
      matches ? (
        <Redirect />
      ) : (
        <BrowserRouter forceRefresh={true}>
            <App />
        </BrowserRouter>
      )
    }
  </Media>
);

AppRegistry.registerComponent("supotsu", ()=>_App)
AppRegistry.runApplication("supotsu", {
    rootTag: document.getElementById('root')
})
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js